import React from "react";
import PropTypes from 'prop-types';
import { EntryPoint } from '../../models';
import {
    HOME_ROOT,
    HOME_FLIGHTS,
    HOME_DP,
    HOME_HOTELS_ORGANIC,
    HOME_HOTELS_SEARCH_EXTENSION,
    withTrackComponentDisplayed,
} from '../../utils/HtmlEvents';
import { URLUtils } from '../../utils';

const getPixelTrackingComponent = ({
    entryPoint = EntryPoint.HOME,
    isSearchExtension,
}) => {
    const trackingLabelByEntryPoint = new Map([
        [EntryPoint.HOTELS, HOME_HOTELS_ORGANIC],
        [EntryPoint.DP, HOME_DP],
        [EntryPoint.FLIGHTS, HOME_FLIGHTS],
    ]);
    let computedLabel = trackingLabelByEntryPoint.get(entryPoint) ?? HOME_ROOT;
    if (entryPoint === EntryPoint.HOTELS && isSearchExtension) {
        computedLabel = HOME_HOTELS_SEARCH_EXTENSION;
    }
    return withTrackComponentDisplayed("div", computedLabel);
};

export const PixelTracking = ({ entryPoint }) => {
    const searchParams = URLUtils.getSearch();
    const isSearchExtension = searchParams.includes('searchExtension=true');

    const PixelTrackingWithTrackComponentDisplayed = getPixelTrackingComponent({
        entryPoint,
        isSearchExtension,
    });
    return (<PixelTrackingWithTrackComponentDisplayed />);
};

PixelTracking.propTypes = {
    entryPoint: PropTypes.oneOf([
        EntryPoint.HOTELS,
        EntryPoint.DP,
        EntryPoint.FLIGHTS,
    ])
};
